
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]/inquiries/[id]",
      function () {
        return require("private-next-pages/events/[slug]/inquiries/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[slug]/inquiries/[id]"])
      });
    }
  